import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ViewCountProduct } from "../../../api/products";
import { getCookie } from "../../../common/auth";
import { priceComma } from "../../../common/splicePrice";
import { getDate } from "../../../common/util/getDate";
import * as List from "./Print.styles";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../../redux/action/confirm";

const PrintProductsList = ({
  productList,
  printCartItems,
  dummyList,
  listModal,
  handleListModal,
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
  addPrintCart,
}) => {
  const router = useRouter();
  const [confirmItems, setConfirmItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);

  // 상품 체크
  const selectItem = (e, el, i) => {
    const tempArr = [...selectedItem];
    tempArr[i] = e.target.checked;
    setSelectedItem(tempArr);
    if (e.target.checked) {
      const tempArr2 = [el, ...confirmItems];
      setConfirmItems(tempArr2);
    } else {
      const tempArr2 = [...confirmItems];
      const index = tempArr2.findIndex((product) => product.pcode === el.pcode);
      tempArr2.splice(index, 1);
      setConfirmItems(tempArr2);
    }
  };

  // 전체 선택
  const selectAllItems = (e) => {
    if (e.target.checked) {
      const tempArr = new Array(productList.length).fill(true);
      setSelectedItem(tempArr);
      setConfirmItems(productList);
    } else {
      const tempArr2 = new Array(productList.length).fill(false);
      setSelectedItem(tempArr2);
      setConfirmItems([]);
    }
  };

  // 전체삭제
  const deleteAll = () => {
    const content = {
      title: "전부 삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: () => {
        setConfirmItems([]);
        setSelectedItem([]);
        successAlert("장바구니 전체 삭제 완료");
        closeConfirmModal();
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  useEffect(() => {
    if (!listModal) return;
    const tempArr2 = new Array(productList.length).fill(false);
    setSelectedItem(tempArr2);
  }, [productList, listModal]);

  return (
    <>
      <List.TableTypeWrapper className="container">
        <List.Table>
          <thead>
            <tr className="header">
              <th className="custome-checkbox">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`all`}
                  onChange={(e) => selectAllItems(e)}
                  checked={!selectedItem.includes(false)}
                />
                <label htmlFor="all" className="form-check-label" />
              </th>
              <th className="img">이미지</th>
              <th className="name">품명</th>
              <th className="sizes">사이즈</th>
              <th className="onePrice">단가</th>
              <th className="quantity">묶음 수량</th>
              <th>판매가</th>
              <th>인쇄 비용</th>
              <th>예상 합 가격</th>
            </tr>
          </thead>
          <tbody>
            {productList &&
              productList.length > 0 &&
              productList.map((product, i) => (
                <tr key={i}>
                  <td className="custome-checkbox">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={product.pcode}
                      onChange={(e) => selectItem(e, product, i)}
                      checked={selectedItem[i]}
                    />
                    <label
                      className="form-check-label"
                      style={{
                        textTransform: "capitalize",
                      }}
                      htmlFor={product.pcode}
                    />
                  </td>
                  <td className="img">
                    <Link href={`/products/${product.ename}/${product.pcode}/`}>
                      <a>
                        <img src={product.main_image} alt={product.pname} />
                      </a>
                    </Link>
                  </td>
                  <td className="name">
                    <Link href={`/products/${product.ename}/${product.pcode}/`}>
                      <a>{product.pname}</a>
                    </Link>
                  </td>
                  <td className="sizes">
                    {(product.horizontal != 0 ? product.horizontal : "-") +
                      (product.vertical != 0 ? "X" + product.vertical : "") +
                      (product.height != 0 ? "X" + product.height : "")}
                  </td>
                  <td className="onePrice">
                    {priceComma(
                      Math.round(
                        Number(product.discount_price) /
                          Number(product.quantity)
                      )
                    )}
                    원
                  </td>
                  <td className="quantity">{priceComma(product.quantity)}개</td>
                  <td className="price">
                    <List.PriceBox>
                      {product.salePer > 0 && (
                        <div>
                          <span>
                            {product.price && ` ${priceComma(product.price)}원`}
                          </span>
                        </div>
                      )}
                      {priceComma(product.discount_price)}원
                    </List.PriceBox>
                  </td>
                  <td className="print_price">
                    {priceComma(
                      Number(product.small_price) * Number(product.quantity)
                    )}
                    원
                  </td>
                  <td className="total_price">
                    {priceComma(
                      Number(product.discount_price) +
                        Number(product.small_price) * Number(product.quantity)
                    )}
                    원
                  </td>
                </tr>
              ))}
          </tbody>
        </List.Table>
      </List.TableTypeWrapper>
      <List.BtnWrapper>
        <button
          className="btn"
          onClick={() => {
            setConfirmItems([]);
            setSelectedItem([]);
            addPrintCart(confirmItems);
          }}
        >
          선택 견적 담기
        </button>
      </List.BtnWrapper>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintProductsList);
